export const dashInvoices = {
  invoices: {
    title: "Zu versendende Rechnungen",
    subtitle: "Hier sehen Sie Anfragen, die auf die Rechnungsstellung warten.",
    loading: "Wird geladen…",
    empty: "Keine Rechnungen zu versenden.",
    guestFallback: "Gast",
    manualBadge: "Manuell",
    manualBadgeTitle: "Nicht automatisch erzeugt: Sie stellen sie manuell aus",
    manualCheckoutTitle: "Nicht automatisch erzeugt: manuell ausstellen",
    linkSentTitle: "Link an den Gast gesendet",
    linkPendingTitle: "Der Link wird am Tag des Check-out gesendet",
    manualIssue: "Manuelle Ausstellung",
    sendLinkTitle: "Dem Gast den Link senden, um seine Rechnungsdaten zu vervollständigen",
    resend: "Erneut senden",
    sendLink: "Link senden",
    closeRequestTitle: "Diese Anfrage schließen (Sie stellen sie manuell aus)",
    close: "Schließen",
    cancelAutoTitle: "Automatischen Versand abbrechen, um sie anderweitig manuell zu senden",
    cancel: "Abbrechen",
    viewAll: "Alle Rechnungen ansehen",
    confirmCancel: {
      title: "Automatischen Versand abbrechen?",
      html: "Der Rechnungslink wird dem Gast nicht gesendet.<br>Sie können ihn manuell auf anderem Weg senden.",
      confirm: "Ja, abbrechen",
      cancel: "Nein",
    },
    confirmSend: {
      title: "Rechnungslink senden?",
      html: "Der Link zum Vervollständigen der Steuerdaten wird dem Gast per WhatsApp gesendet.<br>Die Rechnung stellen Sie manuell aus.",
      confirm: "Ja, senden",
      cancel: "Nein",
    },
    cancelError: {
      title: "Abbrechen nicht möglich",
    },
    closeError: {
      title: "Schließen nicht möglich",
    },
    sendError: {
      title: "Senden nicht möglich",
    },
    sendSuccess: {
      title: "Link gesendet",
      text: "Der Gast hat den Rechnungslink erhalten.",
    },
    retry: "Bitte versuchen Sie es erneut.",
  },
  balances: {
    title: "Offene Beträge",
    subtitle: "Buchungen mit offenem Betrag.",
    total: "Gesamt",
    paid: "Zahlung verarbeitet",
    loading: "Wird geladen…",
    empty: "Keine offenen Beträge.",
    emptySub: "Wenn eine Buchung einen offenen Betrag hat, erscheint sie hier.",
    viewAll: "Alle offenen Beträge ansehen",
  },
  balancesDrawer: {
    title: "Offene Beträge",
    close: "Schließen",
    from: "Von",
    to: "Bis",
    sort: "Sortieren",
    sortArrival: "Check-in-Datum",
    sortProximity: "Nähe zur Anreise",
    searchPlaceholder: "Unterkunft suchen…",
    allAccommodations: "Alle Unterkünfte",
    noResults: "Keine Ergebnisse",
    clear: "Zurücksetzen",
    totalPending: "Offen gesamt",
    ofTotal: "von {amount} {currency}",
    loading: "Wird geladen…",
    empty: "Keine Buchungen mit offenem Betrag.",
    end: "Nicht mehr.",
    tags: {
      ended: "Aufenthalt beendet",
      now: "Im Haus",
      today: "Kommt heute an",
      tomorrow: "Kommt morgen an",
      dayAfter: "Kommt in 2 Tagen an",
    },
  },
};
